/* @flow */

import type { NETGEM_API_V8_DATA_COLLECTION_BATCH_PAYLOAD } from '../../v8/types/DataCollection';
import type { NETGEM_API_V8_REQUEST_HEADERS } from '../../v8/types/Headers';
import type { NETGEM_API_V8_REQUEST_RESPONSE } from '../../v8/types/RequestResponse';

import sendV8Request from '../../v8/requests/v8';
import { HttpMethod } from '../../v8/types/HttpMethod';

const sendV8DataCollectionRequest: (
  url: string,
  content: NETGEM_API_V8_DATA_COLLECTION_BATCH_PAYLOAD,
  method: HttpMethod,
  headers: NETGEM_API_V8_REQUEST_HEADERS,
  signal?: AbortSignal,
) => Promise<NETGEM_API_V8_REQUEST_RESPONSE> = (url, content, method, headers, signal) => sendV8Request(url, null, JSON.stringify(content), headers, null, signal, null, method);

const sendV8DataCollectionCollectorIdRequest: (url: string, authenticationToken: string | null, signal?: AbortSignal) => Promise<NETGEM_API_V8_REQUEST_RESPONSE> = (url, authenticationToken, signal) =>
  sendV8Request(url, authenticationToken, null, [], null, signal);

export { sendV8DataCollectionCollectorIdRequest, sendV8DataCollectionRequest };
